import React from 'react';
import Navbar from '../components/landing/Navbar';
import Footer from '../components/landing/Footer';
import { Mail, MessageCircle } from 'lucide-react';

const ContactPage = () => {
  const handleWhatsAppClick = (e) => {
    e.preventDefault();
    window.open('https://api.whatsapp.com/send?phone=573011920219&text=Hola,%20necesito%20información%20sobre%20JG%20Models', '_blank');
  };

  return (
    <div className="min-h-screen bg-[#1d1e20]">
      <Navbar />
      <div className="container mx-auto px-4 py-24">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-8 text-white">
            Contáctanos
          </h1>
          <p className="text-xl text-gray-300 mb-12">
            Estamos aquí para responder todas tus preguntas
          </p>
          
          <div className="bg-[#000000] p-12 rounded-2xl border border-[#c8784e]/20">
            <div className="flex flex-col items-center gap-8">
              <div className="flex items-center gap-4 text-[#c8784e]">
                <Mail size={32} />
                <a href="mailto:gestion2jgmodels.com" className="text-2xl hover:text-[#d89a6f] transition-colors">
                  gestion2jgmodels.com
                </a>
              </div>
              
              <div className="mt-8">
                <button 
                  onClick={handleWhatsAppClick}
                  className="inline-flex items-center gap-3 bg-[#c8784e] text-black px-8 py-4 rounded-full font-semibold text-lg hover:bg-[#d89a6f] transition-all duration-300 hover:scale-105 cursor-pointer"
                >
                  <MessageCircle size={24} />
                  Escríbenos por WhatsApp
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;